import { View, Text, StyleSheet } from "react-native";
import React from "react";

import GlobalStyles from "../../Resources/Styles";
import Colors from "../../Resources/Color";
import Fonts from "../../Resources/Fonts";
import { useScreenDimensions, useDevice } from "../_layout";
import { useTranslation } from "react-i18next";

const SerieRowHeader = ({ exercise, showSetPriority }) => {
  const { t } = useTranslation();
  const { isMobile } = useDevice();
  const { screenSize } = useScreenDimensions();

  return (
    <View
      style={{
        width: "100%",
        paddingHorizontal: 10,
        marginBottom: 5,
      }}
    >
      <View
        style={[
          GlobalStyles.HStack,
          {
            width: "100%",
            justifyContent: "space-between",
            // marginBottom: 5,
          },
        ]}
      >
        <View style={{ width: showSetPriority ? "8%" : "4%" }} />
        <Text
          style={{
            width: screenSize === "small" ? "39.75%" : "37.5%",
            textAlign: "center",
            fontSize: screenSize === "small" ? 13 : 13,
            fontWeight: "600",
            color: Colors.grayColor,
          }}
          numberOfLines={1}
        >
          {t("target-string")}
        </Text>
        <View style={{ width: screenSize === "small" ? "6%" : "5%" }} />
        <Text
          style={{
            width: screenSize === "small" ? "39.75%" : "37.5%",
            textAlign: "center",
            fontSize: screenSize === "small" ? 13 : 13,
            fontWeight: "600",
            color: Colors.grayColor,
          }}
          numberOfLines={1}
        >
          {t("actual-string")}
        </Text>
        <View style={{ width: screenSize === "small" ? "5%" : "8%" }} />
      </View>

      <View
        style={[
          GlobalStyles.HStack,
          {
            width: "100%",
            justifyContent: "space-between",
            // marginBottom: 5,
          },
        ]}
      >
        <View style={{ width: showSetPriority ? "8%" : "4%" }} />
        <View
          style={{
            height: 1,
            backgroundColor: Colors.borderColor,
            width: screenSize === "small" ? "39.75%" : "37.5%",
            marginVertical: 5,
          }}
        />
        <View style={{ width: screenSize === "small" ? "6%" : "5%" }} />
        <View
          style={{
            height: 1,
            backgroundColor: Colors.borderColor,
            width: screenSize === "small" ? "39.75%" : "37.5%",
            marginVertical: 5,
          }}
        />
        <View style={{ width: screenSize === "small" ? "5%" : "8%" }} />
      </View>

      <View
        style={[
          GlobalStyles.HStack,
          {
            width: "100%",
            justifyContent: "space-between",
            marginBottom: 5,
          },
        ]}
      >
        <View style={{ width: showSetPriority ? "8%" : "4%" }} />
        <Text
          style={{
            width: screenSize === "small" ? "13%" : "12%",
            textAlign: "center",
            fontSize: screenSize === "small" ? 11 : 12,
            fontWeight: "600",
            color: Colors.grayColor,
            maxWidth: 56,
          }}
          numberOfLines={1}
        >
          {t("weight-string")}
        </Text>
        <Text
          style={{
            width: screenSize === "small" ? "13%" : "12%",
            textAlign: "center",
            fontSize: screenSize === "small" ? 11 : 12,
            fontWeight: "600",
            color: Colors.grayColor,
            maxWidth: 56,
          }}
          numberOfLines={1}
        >
          REPS
        </Text>
        <Text
          style={{
            width: screenSize === "small" ? "13%" : "12%",
            textAlign: "center",
            fontSize: screenSize === "small" ? 11 : 12,
            fontWeight: "600",
            color: Colors.grayColor,
            maxWidth: 56,
          }}
          numberOfLines={1}
        >
          {exercise.getRirOrRpe ? "RIR" : "RPE"}
        </Text>
        <View style={{ width: screenSize === "small" ? "6%" : "5%" }} />
        <Text
          style={{
            width: screenSize === "small" ? "13%" : "12%",
            textAlign: "center",
            fontSize: screenSize === "small" ? 11 : 12,
            fontWeight: "600",
            color: Colors.grayColor,
            maxWidth: 56,
          }}
          numberOfLines={1}
        >
          {t("weight-string")}
        </Text>
        <Text
          style={{
            width: screenSize === "small" ? "13%" : "12%",
            textAlign: "center",
            fontSize: screenSize === "small" ? 11 : 12,
            fontWeight: "600",
            color: Colors.grayColor,
            maxWidth: 56,
          }}
          numberOfLines={1}
        >
          REPS
        </Text>
        <Text
          style={{
            width: screenSize === "small" ? "13%" : "12%",
            textAlign: "center",
            fontSize: screenSize === "small" ? 11 : 12,
            fontWeight: "600",
            color: Colors.grayColor,
            maxWidth: 56,
          }}
          numberOfLines={1}
        >
          {exercise.getRirOrRpe ? "RIR" : "RPE"}
        </Text>
        <View style={{ width: screenSize === "small" ? "5%" : "8%" }} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  background: {
    height: 60,
    // backgroundColor: "white", // Assuming you have this color defined elsewhere
    borderRadius: 10,
    paddingHorizontal: 10,
    justifyContent: "center",
    shadowLayer: {
      backgroundColor: "rgba(0,0,0,0.1)", // Adjust this for shadow color
      position: "absolute",
      top: 3,
      bottom: 3,
      left: 3,
      right: 3,
      borderRadius: 10,
    },
    shadowColor: Colors.bubbleColor, // Assuming you have this color defined elsewhere
    shadowOffset: { width: 2, height: 2 },
    shadowOpacity: 0.5,
    shadowRadius: 1,
    elevation: 1,
    marginHorizontal: 10, // Corresponds to .padding(.horizontal) in SwiftUI
  },
  title: {
    fontSize: 14,
    fontWeight: "500",
  },
  statisticsRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  statisticLabel: {
    fontSize: 13,
  },
  statisticValue: {
    flex: 1,
    fontSize: 13,
    fontWeight: "500", // Medium weight
    marginLeft: 5,
  },
});
export default SerieRowHeader;
